import React from 'react';
import CommandOutput from './CommandOutput';

class CommandMessage extends CommandOutput {
  constructor(message) {
    super();
    this.message = message;
  }

  render() {
    return <span>{this.message}</span>;
  }
}

export default CommandMessage;
